import { createFileRoute, redirect } from "@tanstack/react-router";

// Retired 2026-09-09 (B-new-753). This route shipped a hardcoded-English privacy
// policy that named a controller which does not exist — "Xeito Ltd., Registered
// in Spain" — contradicting this same app's legalNotice.sections.identification
// ("Abellan Labs, S.L.U." / NIF B25954249). "Xeito Ltd." appeared exactly once in
// the whole repo: on that page. That is a GDPR Art. 13(1)(a) controller-identity
// defect, and it was consent-critical: sign-up linked to the marketing policy
// while the checkout modal linked here, so a user accepted one Art. 13 notice at
// registration and was shown a different one at payment.
//
// The page was also missing four mandatory disclosures the marketing policy
// carries — Art. 13(1)(c) legal bases, 13(1)(e) recipients, 13(1)(f) transfers
// and 13(2)(a) retention — so translating it into 8 locales would have meant
// translating the defect. Redirecting to the single maintained source is the
// same remedy applied to refund-policy.tsx on 2026-07-26, for the same reason:
// do not maintain two divergent legal texts.
//
// Spain's co-official languages resolve to castellano HERE rather than at the
// edge, so the user takes one hop instead of two. Mirrors the rules in
// apps/marketing/public/_redirects; see legal.languageNote.
const CASTELLANO_FALLBACK_LOCALES = ["ca", "va", "gl", "eu"];
const MARKETING_URL = import.meta.env.VITE_MARKETING_URL || "https://xeito.ai";

export const Route = createFileRoute("/$locale/privacy-policy")({
  beforeLoad: ({ params }) => {
    const locale = CASTELLANO_FALLBACK_LOCALES.includes(params.locale)
      ? "es"
      : params.locale;
    throw redirect({
      href: `${MARKETING_URL}/${locale}/privacy-policy/`,
      reloadDocument: true,
    });
  },
});
